<template>
  <div v-show="visible" class="back-to-top" @click="scrollToTop" @mouseenter="hover=true" @mouseleave="hover=false">
    <div class="top-btn" :class="{ 'hovered': hover }">
      <img v-if="!hover" src="../assets/img/logo.png" alt="logo" class="logo-img" />
      <img v-else src="../assets/img/arrow-up.png" alt="arrow" class="arrow-img" />
    </div>
    <transition name="fade">
      <div v-if="hover" class="top-tip">回到顶部</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BackToTop",
  data() {
    return {
      visible: false,
      hover: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.visible = window.scrollY > 200;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  right: 40px;
  bottom: 60px;
  z-index: 9999;
  cursor: pointer;
  opacity: 0.95;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.top-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(44,62,80,0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: transform 0.3s cubic-bezier(.25,.8,.25,1), box-shadow 0.3s;
}
.top-btn.hovered {
  transform: scale(1.18);
  box-shadow: 0 8px 24px rgba(44,62,80,0.28);
}
.logo-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.arrow-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.top-tip {
  margin-top: 8px;
  background: rgba(255,255,255,0.95);
  color: #14679f;
  font-size: 14px;
  padding: 4px 16px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(44,62,80,0.10);
  white-space: nowrap;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
